import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AddressInput from 'modules/core/components/AddressInput'
import FormRow from 'modules/core/components/FormRow'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import asyncAction from 'modules/core/lib/asyncAction'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import LocationForm from 'modules/locations/lib/forms/LocationForm'

interface Props {
  legalEntity: LegalEntity
}

const LegalEntityAddress: React.FC<Props> = ({ legalEntity }: Props) => {
  const form: LocationForm = useLazyRef(() => new LocationForm(legalEntity.toJS())).current
  const hasPayroll = (): boolean => {
    return hasFeature('payroll')
  }

  const submit = () => {
    return asyncAction(() => form.save(legalEntity))
  }

  const renderForm = () => (
    <div data-intercom-target="settings-address-form">
      <FormRow>
        <AddressInput mandatory={hasPayroll()} form={form} />
      </FormRow>
      {form.isDirty && (
        <FormRow>
          <Button onClick={submit}>{i18n.t('common.submit')}</Button>
        </FormRow>
      )}
    </div>
  )

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="sign-post"
        title={i18n.t('settings.edit_company.address_form.title')}
        description={i18n.t('settings.edit_company.address_form.description')}
      />
      {renderForm()}
    </PanesPadForm>
  )
}

export default observer(LegalEntityAddress)
